import { render } from "./NeedSubscription.vue?vue&type=template&id=6a4fd71e&scoped=true"
import script from "./NeedSubscription.vue?vue&type=script&lang=js"
export * from "./NeedSubscription.vue?vue&type=script&lang=js"

import "./NeedSubscription.vue?vue&type=style&index=0&id=6a4fd71e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4fd71e"]])

export default __exports__